import {useContext} from 'react';
import {TrackingContext} from '@homeaway/react-event-tracking';

import {carouselEvents} from '../utils/edap/edapEvents';
import {EVENT_TYPES} from '../utils/edap/edapEventsConstants';

export default function useEdapEvent(carouselType) {
    const context = useContext(TrackingContext);
    const events = carouselEvents[carouselType];

    return {
        [EVENT_TYPES.PRESENTED]: (carouselData) =>
            events[EVENT_TYPES.PRESENTED]({context, carouselData}),
        [EVENT_TYPES.SELECTED]: (carouselData) =>
            events[EVENT_TYPES.SELECTED]({context, carouselData}),
        [EVENT_TYPES.UPDATED]: (carouselData) =>
            events[EVENT_TYPES.UPDATED]({context, carouselData}),
    };
}
